import { RunEnv, RunMode } from '@abg/typings/page';
import { safeToLowerCase } from '@abg/web-core/common/utils/string/safe-to-lower-case';

const NODE_ENV: string | undefined = process.env['NODE_ENV'];
const DEV_MODE: string | undefined = process.env['DEV_MODE'];

/**
 * @deprecated This variable is deprecated and will be removed in future versions.
 */
export const IS_DEV_MODE: boolean =
  safeToLowerCase(DEV_MODE) === 'true' &&
  safeToLowerCase(NODE_ENV) === 'development';

export const RUNENV_KEY = 'NEXT_PUBLIC_RUNENV';

export const RUNENV: RunEnv = safeToLowerCase(
  process.env[RUNENV_KEY] ?? 'local',
) as RunEnv;
4;

export const RUNMODE_KEY = 'NEXT_PUBLIC_RUNMODE';
export const RUNMODE: RunMode = safeToLowerCase(
  process.env[RUNMODE_KEY] ?? 'publish',
) as RunMode;

/** This var has 'SERVER' in name, cause it prod mode it is accessible only in server */
export const IS_AUTHOR_RUNMODE_SERVER: boolean = RUNMODE === 'author';
/** This var has 'SERVER' in name, cause it prod mode it is accessible only in server */
export const IS_PUBLISH_RUNMODE_SERVER: boolean = !IS_AUTHOR_RUNMODE_SERVER;
